import { createContext, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { agentPermissionsApi } from "../services/api";
import { useAuth } from "./AuthContext";

export const AGENT_PERMS_ME_KEY = "agent-permissions-me";

const AgentPermissionsContext = createContext({ permissions: [], loading: false, failed: false, can: () => false });

export function AgentPermissionsProvider({ children }) {
  const { user } = useAuth();

  const { data, isLoading, isError } = useQuery({
    queryKey: [AGENT_PERMS_ME_KEY, user?.id ?? null],
    queryFn: () => agentPermissionsApi.me(),
    enabled: !!user,
    staleTime: 30_000,
  });

  const permissions = data?.permissions ?? [];
  const can = (permission) => permissions.includes(permission);

  return (
    <AgentPermissionsContext.Provider value={{ permissions, loading: isLoading && !!user, failed: isError && !data, can }}>
      {children}
    </AgentPermissionsContext.Provider>
  );
}

export const useAgentPermissions = () => useContext(AgentPermissionsContext);
